import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useMarketingClient, MarketingClient } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<MarketingClient>
      useData={useMarketingClient}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

